export enum NavTheme {
  LIGHT = "light",
  BLACK = "black",
  DEFAULT = "default",
}
